/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Status_ClosedInputs */

const en_settings_tickets_status_closed = /** @type {(inputs: Settings_Tickets_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const zh_settings_tickets_status_closed = /** @type {(inputs: Settings_Tickets_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已关闭`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Settings_Tickets_Status_ClosedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_status_closed = /** @type {((inputs?: Settings_Tickets_Status_ClosedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Status_ClosedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_status_closed(inputs)
	return zh_settings_tickets_status_closed(inputs)
});
export { settings_tickets_status_closed as "settings.tickets.status_closed" }